import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { formOptions } from 'forms/utils/formOptions';

const fields: FieldsDefinitions = [
  {
    name: 'message',
    label: 'Message (optional)',
    bindings: 'TextField',
    value: undefined,
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
